import React from 'react'

// eslint-disable-next-line no-unused-vars
import { IOrderContext } from '../interfaces/order'

export const OrderContext = React.createContext<IOrderContext>({
  order: undefined,
  setOrder: () => {},
  sort: () => []
})
